module.exports = __webpack_public_path__ + "img/XT-HerramientaManual.9ac9939b.png";